<template>
  <div id="ProductCateList" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">C</span>ategorías</div>
        <div class="col-3 t-r f22 pr3"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12 pt3 pb10 bg-color1" style="overflow-y: auto;">
      <div class="col-12 bb1" v-for="(cate,cate_i) in data_list" v-bind:key="cate_i" @click="set_cate_args(cate_i)">
        <div class="col-12">
          <div class="col-12 bg-color-white p5 color-muted">
              <div class="col-12 pl10">
                <div class="col-10 f14 uppercase pb2 el1 pt2" :class="$store.state.app_args.cate_id == cate.id ? 'color-black' : ''">
                  <div class="col-12 f14 uppercase">{{ cate.cate_code }} </div>
                  <div class="col-12 f14 uppercase pb2 el1">{{ cate.cate_name }}</div>
                </div>  
                <div class="col-2 t-r pt10"><i class="iconfont f18" :class="$store.state.app_args.cate_id == cate.id ? 'icon-Raidobox-xuanzhong color-primary' : 'icon-Raidobox-weixuan color-muted'"></i></div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProductCateList',
  data () {
    return {
      data_list: [],
    }
  },
  created: function () {
    this.get_list_data();
  },
  methods: {
    get_list_data() {
      var post_data = {};
      this.post(this.api_url + 'manage/product_cate', post_data).then((res)=>{
        if(res.status == 1){
          this.data_list = res.data.product_cate;
        }else{
          this.data_list = []
        }
      })
    },
    set_cate_args(i){
      let cate_id = this.data_list[i].id;
      let cate_name = this.data_list[i].cate_name;
      this.$store.commit('setAppArgs',{cate_id: cate_id, cate_name: cate_name});
      this.$router.back(-1);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/ProductCateList.vue